import { AppSettings } from '../constants';
import Jwt from '../helper/interceptors';
import { ObjToParam, MapResponse } from '../helper/helper-api';
import removeDiacritics from '../helper/remove-diacritics';
import { v4 as uuidv4 } from 'uuid';
import S3 from 'aws-sdk/clients/s3';
import { config, Credentials } from 'aws-sdk/lib/core';
export const search = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get(`/api/projects/search?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListProject = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get(`/select-lists/projects?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListLot = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false, {
    headers: [{ key: 'Key', value: params.id }]
  })
    .get(`/api/projects/${params.id}/lots-select-list?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getById = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params }]
  })
    .get(`/api/projects/${params}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const create = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .post('/api/projects', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const update = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .put('/api/projects', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getListProjectAssignmentUser = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get(`/api/projects/${params.projectId}/assigned-users-to-project`, params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const assignUserToProject = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .put(`/api/projects/${params.projectId}/assign-users`, params.param)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getListBuilderUser = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get(
      `/api/projects/${params.projectId}/users-not-yet-assigned-project-select-list`,
      params
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getListUserSelect = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false, {
    headers: [{ key: 'Key', value: params.projectId }]
  })
    .get(
      `/api/projects/${params.projectId}/users-has-assigned-project-select-list`
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectSubcontractorListProject = params => {
  return Jwt(AppSettings.GLOBAL_API_URL, false)
    .get(
      `/apiv1/request-for-services/subcontractors/select-list-projects-items?${ObjToParam(
        params
      )}`
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectBuilderListProject = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get(`/api/reports/project-select-list?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

//Project Setting
export const getProjectSetting = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false, {
    headers: [{ key: 'Key', value: params.projectId }]
  })
    .get(`/api/projects/${params.projectId}/settings`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const updateProjectSetting = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.projectId }]
  })
    .put(`/api/projects/${params.projectId}/settings`, params.param)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const addNewBuilderInventoryItem = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .post('/api/v2/builder/inventory/items/add', params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getProjectSettingNoticeRFS = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false, {
    headers: [{ key: 'Key', value: params.projectId }]
  })
    .get(`/api/projects/${params.projectId}/settings/request-for-services`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const updateProjectSettingNoticeRFS = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.projectId }]
  })
    .put(
      `/api/projects/${params.projectId}/settings/request-for-services`,
      params.param
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const createAssigneeNotice = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.id }]
  })
    .put(`/api/projects/${params.id}/notices`, params.param)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getAssigneeNoticeByProject = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, {
    headers: [{ key: 'Key', value: params.id }]
  })
    .get(`/api/projects/${params.id}/notices`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getProjectByUserId = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get(`/api/projects/projects-by-userId/${params.userId}/${params.isOwner}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const reassignProjectOwner = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .put('/api/projects/reassign-project-owner', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const reassignProjectCoordinator = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .put('/api/projects/reassign-project-coordinator', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getProjectDocumentTypeList = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get(`/api/projects/${params.projectId}/document-types`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getProjectDocumentByDocumentType = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get(
      `/api/projects/${params.projectId}/documents/${params.projectDocumentTypeId}`
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const uploadProjectDocumentToServer = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .post(
      `/api/projects/${params.projectId}/documents/${params.projectDocumentTypeId}`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const removeProjectDocument = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .delete(
      `/api/projects/${params.projectId}/documents/${params.projectDocumentId}`
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const updateProjectDocumentName = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .put(
      `/api/projects/${params.projectId}/documents/${params.projectDocumentId}`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getProjectDocumentShareLot = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get(
      `/api/projects/${params.projectId}/documents/${params.projectDocumentId}/shared-lots`
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const updateProjectDocumentShareLot = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .put(
      `/api/projects/${params.projectId}/documents/${params.projectDocumentId}/shared-lots`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const exportProjectList = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true, { responseType: 'blob' })
    .get(`/api/projects/export?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response, true);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const updateHomeownerFolderTitle = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .put(
      `/api/projects/${params.projectId}/document-types/${params.documentTypeId}`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const updateHomeownerCategoryTitle = params => {
  return Jwt(params.url)
    .post(`/api/v2/homeowner/documents/update-category`,
      params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const importRFSToProject = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .post(
      `/api/imports/projects/${params.projectId}/request-for-services`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getImportStatusByProject = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get(`/api/imports/projects/${params.projectId}`, {})
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const importWorkOrderToProject = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .post(`/api/imports/projects/${params.projectId}/work-orders`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const importPurchaseOrderToProject = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .post(`/api/imports/projects/${params.projectId}/purchase-orders`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getListDefaultCustomTemplate = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get(`/api/electric-orientation-checklists/projects/${params.projectId}/templates`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const getListDefaultCustomTemplate2 = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get(`/api/electronic-punch-list-templates?projectId=${params.projectId}`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const createNewProjectEOCTemplate = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .post(`/api/electric-orientation-checklists/projects/${params.projectId}/templates`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const createNewProjectEPLTemplate = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .post('/api/electronic-punch-list-templates', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const editCustomTemplate = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .put(`/api/electric-orientation-checklists/projects/${params.projectId}/templates/${params.templateId}`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const editEPLTemplate = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .put('/api/electronic-punch-list-templates', params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const selectListCustomTemplate = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .put(`api/electric-orientation-checklists/projects/${params.projectId}/templates/${params.templateId}/selection`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const getCustomTemplateDetail = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get(`api/electric-orientation-checklists/projects/${params.projectId}/templates/${params.templateId}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const getCustomTemplateDetail2 = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get(`api/electronic-punch-list-templates/${params.templateId}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const getBuilderName = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get('api/builder-infos/get-builder-name', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const duplicateEOCTemplate = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .post(`api/electric-orientation-checklists/projects/${params.projectId}/templates/${params.templateId}/duplicate`, params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const copyEOCTemplate = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .post(`api/electric-orientation-checklists/projects/${params.sourceProjectId}/templates/${params.templateId}/copy/${params.targetProjectId}`, params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const copyEOFTemplate = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .post('api/electronic-punch-list-templates/copy-template', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const getListCopyEOCProject = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get(`api/projects/drop-down-list/copy-eoc-template?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

//Home category API
export const createNewCategory = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .post('api/category-for-builders', params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const suggestInfoCategory = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get(`api/template-category-for-builders/get-suggestion-template?templateName=${params.categoryName}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const getSelectedTemplateCategory = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get(`api/template-category-for-builders/${params.templateId}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const getListCategory = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`api/category-for-builders?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const getCategoryProfileDetails = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get(`api/category-for-builders/${params.id}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const editCategoryProfile = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .put('api/category-for-builders', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const editCategoryImages = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post(`api/category-image-for-builders?${ObjToParam(params.data)}`, params.param)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const deleteCategoryImages = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .delete(`api/category-image-for-builders/${params.id}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const deleteCategoryItem = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .delete(`api/category-for-builders/${params.id}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

// Home inventory - inventory item API

export const createNewInventoryItem = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post('api/inventory-item-for-builders', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const getListCategoryDropdown = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`/api/inventory-item-for-builders/select-list-categories?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const getListInventoryItem = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post('api/inventory-item-for-builders/get-list-inventory-items', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const getInventoryItemProfile = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`api/inventory-item-for-builders/${params.id}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const getInventoryItemDetail = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`/api/v2/builder/inventory/items/${params.id}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const deleteImageInventoryItem = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .delete(`api/inventory-item-image-for-builders/${params.imageId}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const deleteAttachFileInventoryItem = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .delete(`api/inventory-item-attachment-for-builders/${params.id}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const postImageInventoryItem = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post(`api/inventory-item-image-for-builders?inventoryItemId=${params.id}`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const postAttachFileInventoryItem = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post(`api/inventory-item-attachment-for-builders?inventoryItemId=${params.inventoryId}`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const deleteInventoryItemBuilder = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .delete(`api/inventory-item-for-builders/${params.id}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const editInventoryItem = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .put('api/inventory-item-for-builders', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};


export const updateBuilderInventoryItem = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post('/api/v2/builder/inventory/items/update', params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};


export const getListPhaseToLotInventoryItem = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post('api/inventory-item-lot-for-builders/get-lots-to-pick', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const assignPlanToLotInventoryItem = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post('api/inventory-item-lot-for-builders', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const fetchListLotInventoryItem = async(params) => {
  try {
    const response = await Jwt(AppSettings.CURRENT_SITE_URI, true).get(`api/inventory-item-lot-for-builders?inventoryItemId=${params.id}`);
    return MapResponse(response);
  } catch (error) {
    const response = error.response;
    return MapResponse(response);
  }
};

export const onEditListLotInventoryItem = async(params) => {
  try {
    const response = await Jwt(AppSettings.CURRENT_SITE_URI, true).put('api/inventory-item-lot-for-builders', params);
    return MapResponse(response);
  } catch (error) {
    const response = error.response;
    return MapResponse(response);
  }
};

export const deleteListLotInventoryItem = async(params) => {
  try {
    const response = await Jwt(AppSettings.CURRENT_SITE_URI, true).delete(`api/inventory-item-lot-for-builders/${params.lotId}`);
    return MapResponse(response);
  } catch (error) {
    const response = error.response;
    return MapResponse(response);
  }
};

export const getSuggestTemplateName = async(params) => {
  try {
    const response = await Jwt(AppSettings.CURRENT_SITE_URI, true).get(`api/template-inventory-item-for-builders/get-suggestion-template?templateName=${params.templateName}`);
    return MapResponse(response);
  } catch (error) {
    const response = error.response;
    return MapResponse(response);
  }
};

export const getSuggestData = async(params) => {
  try {
    const response = await Jwt(AppSettings.CURRENT_SITE_URI, true).get(`api/template-inventory-item-for-builders/${params.templateId}`);
    return MapResponse(response);
  } catch (error) {
    const response = error.response;
    return MapResponse(response);
  }
};

export const setupProjectDocumentAWS = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .post('/api/aws/s3/credentials', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const suggestLocationTagsHomeInventory = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get(`api/home-inventory-tag-locations/get-suggestion-location-tags/${params.locationTagName}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getInventoryTemplateList = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get(`api/home-inventory-imports/get-category-templates?projectId=${params.projectId}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;

      return MapResponse(response);
    });
};

export const postInventoryTemplateList = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .post('api/home-inventory-imports/import-category-templates', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;

      return MapResponse(response);
    });
};

export const getInventoryItemTemplateList = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .post('api/home-inventory-imports/get-inventory-item-templates', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;

      return MapResponse(response);
    });
};

export const postInventoryItemTemplateList = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .post('api/home-inventory-imports/import-inventory-item-templates-with-exist-category-names-in-project', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;

      return MapResponse(response);
    });
};

export const postInventoryItemTemplateNotExistList = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .post('api/home-inventory-imports/import-inventory-item-templates', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;

      return MapResponse(response);
    });
};

export const getRequestTypeToMapping = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`api/electronic-punch-list-template-request-types/get-request-types-to-mapping?projectId=${params.projectId}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const postRequestTypeTemplate = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .post('api/electronic-punch-list-template-request-types/create-or-update-request-type', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const deleteRequestTypeTemplate = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .delete(`api/electronic-punch-list-template-request-types/${params.requestTypeId}`, params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const aiScanItemImage = params => {
  const formData = new FormData();
  const files = (params && params.imageFiles) || [];

  files.forEach(file => {
    formData.append('imageFiles', file);
  });

  return Jwt(AppSettings.GLOBAL_API_URL, false)
    .post('/api/ai/item/scan_image', formData)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const aiFindItemDetail = params => {
  const useCustomDetail = params && params.useCustomDetail;
  const payload = params ? { ...params } : {};
  if (payload && Object.prototype.hasOwnProperty.call(payload, 'useCustomDetail')) {
    delete payload.useCustomDetail;
  }

  return Jwt(AppSettings.GLOBAL_API_URL, false)
    .post(
      useCustomDetail
        ? '/api/ai/item/find_custom_detail'
        : '/api/ai/item/find_detail',
      payload
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const aiScanReceipt = params => {
  const formData = new FormData();
  if (params && params.imageFile) {
    formData.append('imageFile', params.imageFile);
  }

  return Jwt(AppSettings.GLOBAL_API_URL, false)
    .post('/api/ai/item/scan_receipt', formData)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const uploadProjectDocumentToS3 = (params, callback) => {
  config.credentials = new Credentials({
    accessKeyId: params.config.accessKeyId,
    secretAccessKey: params.config.secretAccessKey,
    sessionToken: params.config.sessionToken
  });

  const fileName = removeDiacritics(params.file.name);
  const enFileName = uuidv4() + '.' + fileName.split('.').pop();
  const s3 = new S3({ region: params.config.region });

  const payload = {
    ACL: 'public-read',
    Body: params.file,
    Bucket: params.config.bucket,
    ContentType: params.file.type,
    ContentDisposition: 'inline; filename="' + fileName + '"',
    Key: `${params.config.path}/${enFileName}`
  };
  let upload = s3.upload(payload);
  let isDelete = false;
  upload.send((error, data) => {
    if (data) {
      /**
       * callback delete file after upload file success
       */
      if (isDelete) {
        const bucketInstance = new S3({ region: params.config.region });
        bucketInstance.deleteObject(
          {
            Bucket: params.config.bucket,
            Key: `${params.config.path}/${enFileName}`
          },
          (err, res) => {
            if (res) {
              if (process.env.NODE_ENV === 'development') {
                console.log('File deleted successfully');
              }
            } else {
              if (process.env.NODE_ENV === 'development') {
                console.log(
                  'Check if you have sufficient permissions : ' + err
                );
              }
            }
          }
        );
      } else {
        callback(true, { data });
      }
    } else {
      /**
       * callback when upload file success
       */
      callback(false, { data });
    }
  });
  /**
   * callback when user cancel uploading file
   */
  const cancelUpload = () => {
    setTimeout(upload.abort.bind(upload), 100);
  };
  const deleteFile = () => {
    isDelete = true;
  };
  if (params.file.size > 1024 * 1024 * 5) {
    callback('pending', {
      cancelUpload,
      uploadId: params.file.uploadId,
      fileName
    });
  } else {
    callback('delete', {
      deleteFile,
      uploadId: params.file.uploadId,
      fileName
    });
  }
};



// WEBPACK FOOTER //
// ./src/Projects/api.js